import { render, staticRenderFns } from "./EditFullNameModal.vue?vue&type=template&id=50dc18ce&"
import script from "./EditFullNameModal.vue?vue&type=script&lang=js&"
export * from "./EditFullNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports